import { Button, ConfirmationButton, StandardDialog } from "@roc/ui";
import { observer } from "mobx-react";
import { Grid } from "@material-ui/core";
import { useEffect } from "react";
import { GenerateCema } from "./generateCema";
import { useDocumentStore } from "@roc/feature-documents";

export type GenerateCemaDialogProps = {
  open: boolean;
  onClose: () => void;
  loanId: number;
  setButtonDisabled: (boolean) => void;
};

export const GenerateCemaDialog = observer((props: GenerateCemaDialogProps) => {
  const { open, onClose, loanId, setButtonDisabled } = props;

  const {
    documentStore: {
      documentFormStore: { generateCemaStore },
    },
  } = useDocumentStore();

  useEffect(() => {
    if (open) {
      generateCemaStore.reset();
      generateCemaStore.initialize(loanId);
    }
  }, [open]);

  useEffect(() => {
    setButtonDisabled(generateCemaStore.generateDocumentsInProgress);
  }, [generateCemaStore.generateDocumentsInProgress]);

  const onSubmit = () => {
    generateCemaStore.generateCemaDocuments();
    onClose();
  };

  return (
    <StandardDialog
        open={open}
        title="CEMA Documents Details"
        maxWidth="md"
        handleClose={onClose}
        dialogContent={<GenerateCema store={generateCemaStore} />}
        dialogActions={
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item>
              <Button
                onClick={onClose}
                color="primary"
                variant="outlined"
                testId="cancel"
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <ConfirmationButton
                onClick={onSubmit}
                color="primary"
                variant="contained"
                testId="confirm"
                disabled={false}
                confirmDialogProps={{
                  title: 'Confirmation',
                  body:
                    'Are you sure you want to generate the CEMA Documents?',
                }}
              >
                Generate
              </ConfirmationButton>
            </Grid>
          </Grid>
        }
      />
  );
});

export default GenerateCemaDialog;